import { Input } from "src/components/Form/input";
import { UserTransaction } from "../../types/user-transaction.entity";
import { useState } from "react";
import { calcRefundAmountByPercentage } from "../../utils";
import { Button } from "src/components/Form/button";
import { useRefundSessionTransactionMutation } from "../../user-transactions.service";
import { User } from "src/features/users/types/user.entity";
import { useAppDispatch } from "src/store";
import { showToast } from "src/store/toast.store";

type Props = {
  transaction: UserTransaction;
  close: () => void;
  user: User;
};
export const RefundForm = ({ transaction, close, user }: Props) => {
  const [refundSessionTransaction, { isLoading }] = useRefundSessionTransactionMutation();
  const [refundAmount, setRefundAmount] = useState<number>(0);
  const [refundPercentage, setRefundPercentage] = useState(0);
  const dispatch = useAppDispatch();

  const handleChange = (value: string) => {
    const percentage = parseInt(value);
    const refund = calcRefundAmountByPercentage(transaction.amount, percentage);
    setRefundAmount(refund);
    setRefundPercentage(percentage);
  };

  const handleRefundSessionTransaction = async () => {
    try {
      await refundSessionTransaction({
        learnerId: transaction.userId,
        percentage: refundPercentage,
        bookingId: transaction.metadata.bookingId!,
        sessionId: transaction.metadata.sessionId,
      }).unwrap();
      dispatch(
        showToast({ message: `Successfully refunded ${refundPercentage}% to user ${user.name}.`, type: "success" })
      );
      close();
    } catch (error) {
      dispatch(showToast({ message: error as string, type: "error" }));
    }
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="flex items-end gap-3">
        <div className="flex-1">
          <Input
            placeholder="Enter Refund Percentage"
            label="Refund Percentage"
            onChange={handleChange}
            type="percentage"
          />
        </div>
        <Button
          onClick={handleRefundSessionTransaction}
          color="primary"
          type="button"
          className="mb-[6px]"
          disabled={isLoading}
        >
          Refund
        </Button>
      </div>
      {refundAmount > 0 && <p className="text-blue-500 text-sm mt-1">{refundAmount}</p>}
    </div>
  );
};
